module.exports = __webpack_public_path__ + "img/tablet.be5030ca.webp";